import React, { useEffect, useState } from "react";
import {
  Alert,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { definirDestino } from "./ApiServices";

export default function ModalDestinoCheque({ open, onClose, cheque, onOk }) {
  const [destino, setDestino] = useState("depositar");
  const [guardando, setGuardando] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!open) return;
    setDestino("depositar");
    setError("");
  }, [open]);

  const guardar = async () => {
    if (!cheque?.id) return;
    setGuardando(true);
    setError("");
    try {
      await definirDestino(cheque.id, { destino });
      onOk?.();
      onClose?.();
    } catch (err) {
      setError(err.message || "Error al definir destino");
    } finally {
      setGuardando(false);
    }
  };

  const dias = cheque?.dias_desde_emision;

  return (
    <Dialog open={open} onClose={guardando ? undefined : onClose} maxWidth="xs" fullWidth>
      <DialogTitle>
        Destino — N° {cheque?.nro_cheque || cheque?.id || ""}
      </DialogTitle>
      <DialogContent dividers>
        <Stack spacing={2}>
          {error ? <Alert severity="error">{error}</Alert> : null}
          {dias != null && Number(dias) >= 30 ? (
            <Alert severity="warning">
              Lleva {dias} días desde emisión (alerta 30 días corridos).
            </Alert>
          ) : null}
          <Typography variant="body2" color="text.secondary">
            El endoso a proveedores se hace desde la orden de pago. Acá solo
            depositás o retenés el cheque en cartera.
          </Typography>
          <TextField
            select
            SelectProps={{ native: true }}
            label="Destino"
            size="small"
            fullWidth
            value={destino}
            onChange={(e) => setDestino(e.target.value)}
            disabled={guardando}
          >
            <option value="depositar">Depositar</option>
            <option value="retenido">Retener</option>
          </TextField>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={guardando}>
          Cancelar
        </Button>
        <Button
          variant="contained"
          onClick={guardar}
          disabled={guardando}
          startIcon={guardando ? <CircularProgress size={16} color="inherit" /> : null}
        >
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
